import { Component, Input } from '@angular/core';

import { ModalRef } from '@trilogy';

@Component({
    templateUrl: './info-huawei-modal.component.html',
    styleUrls: ['./info-huawei-modal.component.scss'],
})
export class InfoHuaweiModalComponent {
    @Input() public phoneName: string;

    constructor(private modalRef: ModalRef<InfoHuaweiModalComponent>) {}

    public cartAction(): void {
        this.modalRef.close();
    }
}
